import { LOGIN_CHANGE } from '../../actions';

const loginReducer = (oldState = {
  loginVm: {
    email: '',
    password: ''
  }
}, action) => {
  switch (action.type) {
    case LOGIN_CHANGE:
      return {
        ...oldState,
        loginVm: {
          ...oldState.loginVm,
          [action.name]: action.value
        }
      };
    default:
      return oldState;
  }
};

export default loginReducer;



// WEBPACK FOOTER //
// ./src/pages/Login/loginReducer.js